import { render, staticRenderFns } from "./BusinessSettings.vue?vue&type=template&id=3be9e5f8"
import script from "./BusinessSettings.vue?vue&type=script&lang=ts"
export * from "./BusinessSettings.vue?vue&type=script&lang=ts"
import style0 from "./BusinessSettings.vue?vue&type=style&index=0&id=3be9e5f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports